import WorkRoundedIcon from "@mui/icons-material/WorkRounded";

export const work = (props) => {
  return <WorkRoundedIcon {...props} />;
};
